import { Routes } from '@angular/router';

export const homepageRoutes: Routes = [
  {
    path: '',
    title: '尋Way花路 解鎖花蓮特色店家',
    loadComponent: () =>
      import('./pages/main/main.component').then((c) => c.MainComponent),
  },
  {
    path: 'about',
    title: '活動簡介',
    loadComponent: () =>
      import('./pages/about/about.component').then((c) => c.AboutComponent),
  },
  {
    path: 'news',
    title: '最新消息',
    loadComponent: () =>
      import('./pages/news/news.component').then((c) => c.NewsComponent),
  },
  {
    path: 'store',
    title: '參與店家',
    children: [
      {
        path: ':area',
        loadComponent: () =>
          import('./pages/store/store.component').then((c) => c.StoreComponent),
      },
      {
        path: '',
        redirectTo: '北區',
        pathMatch: 'full',
      }
    ]
  },
  {
    path: 'promotion',
    title: '優惠活動',
    loadComponent: () =>
      import('./pages/promotion/promotion.component').then((c) => c.PromotionComponent),
  },
  {
    path: 'faq',
    title: '常見問題',
    loadComponent: () =>
      import('./pages/faq/faq.component').then((c) => c.FaqComponent),
  },
  {
    path: 'reading-event',
    title: '街區走讀活動',
    loadComponent: () =>
      import('./pages/reading-event/reading-event.component').then((c) => c.ReadingEventComponent),
  },
  {
    path: 'theme-event',
    title: '街區主題活動',
    loadComponent: () =>
      import('./pages/theme-event/theme-event.component').then((c) => c.ThemeEventComponent),
  },
  {
    path: 'gift',
    title: '百大伴手禮',
    children: [
      {
        path: ':session',
        children: [
          {
            path: ':type',
            loadComponent: () =>
              import('./pages/gift/gift.component').then((c) => c.GiftComponent),
          },
          {
            path: '',
            redirectTo: '金質獎',
            pathMatch: 'full',
          }
        ]
      },
      {
        path: '',
        redirectTo: '1',
        pathMatch: 'full',
      }
    ]
  },
  {
    path: 'shopping-area',
    title: '商圈資訊',
    loadComponent: () =>
      import('./pages/shopping-area/shopping-area.component').then((c) => c.ShoppingAreaComponent),
  },
  {
    path: 'privacy',
    title: '隱私權政策',
    loadComponent: () =>
      import('./pages/privacy/privacy.component').then((c) => c.PrivacyComponent),
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  }
]